import { action } from 'satcheljs';
/**
 * Called when we select discard, resets the invitation options in store
 */
var discardInvitationOption = action('discardInvitationOption', function () { return ({}); });
export default discardInvitationOption;
//# sourceMappingURL=discardInvitationOption.js.map